import { IChapterList, IDocComplete } from '@/types/summary';
import http from '../services/http';

// 获取未来会议室原文
export async function getCollaborationSrcContent(streamName: string) {
  try {
    const res = await http.get<{ docSrc: IDocComplete; finish: boolean }>(`/api/auth/record-server/meeting/docSrc?streamName=live/${streamName}`);
    return res.data;
  } catch (e) {
    console.log('getCollaborationSrcContent error >>>> ', e);
    return null;
  }
}

// 获取未来会议室智能章节
export async function getCollaborationSmartChapters(streamName: string) {
  try {
    const res = await http.get<IChapterList[]>(`/api/auth/record-server/slice/smart-chapters?streamName=live/${streamName}`);
    return res.data;
  } catch (e) {
    console.log('getCollaborationSmartChapters error >>>> ', e);
    return null;
  }
}

// 连接板端会议
export async function connectMeeting(code: string) {
  try {
    const res = await http.post<{ streamName: string }>(`/api/auth/live-record/${code}/actions/link-board`, {});
    return res.data;
  } catch (e) {
    console.log('connectMeeting error >>>> ', e);
    return null;
  }
}

export async function webConnectMeeting(streamId: string) {
  try {
    const res = await http.post<{ streamName: string }>(`/api/auth/live-record/actions/link-board/${streamId}`, {});
    return res.data;
  } catch (e) {
    console.log('webConnectMeeting error >>>> ', e);
    return null;
  }
}

export async function saveRecord({ streamName }: { streamName: string }) {
  const res = await http.post<{ targetStreamName: string }>('/api/auth/live-record/actions/sync-record', { streamName });
  return res.data;
}

export interface IMeetingStatus {
  /** 会议是否已结束，true: 已结束；false: 录制中 */
  isStop: boolean;
}

export async function getMeetingRecordStatus(streamName: string): Promise<IMeetingStatus | null> {
  try {
    const res = await http.get<IMeetingStatus>(`/api/open/record-server/meeting/record?streamName=${streamName}`);
    console.log('getMeetingRecordStatus', streamName, res);
    return res.data;
  } catch (error) {
    return null;
  }
}
